// AUTO-GENERATED by `npm run codegen` - do not edit.
namespace $ {

export type demo_note_card_likeMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type demo_note_card_likeMutation = { __typename?: 'Mutation', note_like: { __typename?: 'Note', id: string, likes: number } };


export function $demo_note_card_like(variables: demo_note_card_likeMutationVariables, opts?: { revalidate?: boolean }): demo_note_card_likeMutation {
	return $demo_graphql_request(`mutation demo_note_card_like(\u0024id: ID!) {
  note_like(id: \u0024id) {
    id
    likes
  }
}`, variables, opts) as demo_note_card_likeMutation
}

}
